import React, { useState, createContext, useContext } from 'react';
import { LocallyRemovedEventPanelFormFieldsStore } from './locally-removed-fields-store';

type LocallyRemovedEventPanelFormFieldContextType = LocallyRemovedEventPanelFormFieldsStore;

const LocallyRemovedEventPanelFormFieldContext = createContext<
    LocallyRemovedEventPanelFormFieldContextType | undefined
>(undefined);

export function RemovedEventPanelFormFieldsProvider(props: {
    children: React.ReactElement;
}): React.ReactElement {
    const store = useState(() => new LocallyRemovedEventPanelFormFieldsStore())[0];

    return (
        <LocallyRemovedEventPanelFormFieldContext.Provider value={store}>
            {props.children}
        </LocallyRemovedEventPanelFormFieldContext.Provider>
    );
}

export function useLocallyRemovedEventFormFieldsStore(): LocallyRemovedEventPanelFormFieldContextType {
    const store = useContext(LocallyRemovedEventPanelFormFieldContext);
    if (!store) {
        throw new Error('Unexpectedly did not find store for locally removed fields');
    }
    return store;
}
